import * as ActionTypes from './actionTypes';
import initialFormData from '../Modules/formData';
import { propertyType, defaultValues, carouselMode } from '../Enums';
import apiState from '../apiState';
import { path } from '../utils';

export default function globalReducer(state = {}, action) {
  switch (action.type) {
    case ActionTypes.DATA_UPDATE:
      let key = action.data.key;
      let newState = {
        ...state
      };
      newState['formData'][key] = action.data.value;

      return newState;

    case ActionTypes.PROPERTY_TYPE_UPDATE:
      return {
        ...state,
        type_of_property: action.data.value
      };

    case ActionTypes.LOCATION_OBJECT_UPDATE:
      return {
        ...state,
        selected_location: action.data.value
      };

    case ActionTypes.NUMBER_OF_ROOMS_UPDATE:
      return {
        ...state,
        number_of_rooms: action.data.value
      };
  
    case ActionTypes.ESTIMATED_REVENUE_UPDATE:
      return {
        ...state,
        estimated_revenue: action.data.value
      };

    case ActionTypes.LOCATION_UPDATE:
      return {
        ...state,
        location: action.data.value,
        earning_potential_data: apiState.earning_potential_data
      };

    case ActionTypes.START_FETCH_PAGE_DATA:
      return {
        ...state
      };

    case ActionTypes.SUCCESS_FETCH_PAGE_DATA:
      return {
        ...state,
        ...action.data
      };

    case ActionTypes.START_FETCH_SEARCH:
      return {
        ...state,
        locationData: {
          ...state.locationData,
          isFetching: true
        }
      };

    case ActionTypes.SUCCESS_FETCH_SEARCH:
      return {
        ...state,
        locationData: {
          isFetching: false,
          location: action.data
        }
      };

    case ActionTypes.START_PUT_PROPERTY:
      return {
        ...state,
        propertyData: {
          ...state.propertyData,
          isFetching: true
        }
      };

    case ActionTypes.SUCCESS_PUT_PROPERTY:
      return {
        ...state,
        propertyData: {
          isFetching: false,
          data: action.data[0]
        }
      };
  
    case ActionTypes.SUCCESS_PUT_PROPERTY_GEN_OTP:
      return {
        ...state,
        propertyData: {
          isFetching: false
        },
        propertyGenOtpData:{
        data: action.data[0]
        }
      };

    case ActionTypes.FLIP_SCROLL_TO_STEPS_BOOL:
      return {
        ...state,
        scroll_steps_to_partner: action.data
      };

    case ActionTypes.FLIP_SCROLL_TO_PROGRAMS_BOOL:
      return {
        ...state,
        scroll_programs: action.data
      };

    case ActionTypes.ARE_YOU_A_SELLER_BOOL:
      return {
        ...state,
        are_you_a_seller: action.data
      };

    case ActionTypes.MOBILE_HEADER_HEIGHT:
      if (action.data) {
        return {
          ...state,
          header_height: '56px'
        };
      } else {
        return {
          ...state,
          header_height: '84px'
        };
      }

    case ActionTypes.EMPTY_FORM_DATA:
      return {
        ...state,
        formData: {
          ...initialFormData,
          dial_code:state.formData.dial_code,
          mobile_number:''
        },
        type_of_property: propertyType.HOTEL,
        number_of_rooms: defaultValues.number_of_rooms,
        location: '',
        locationData: {
          isFetching: false,
          location: {}
        },
        propertyData: {
          isFetching: false,
          data: {}
        },
          propertyGenOtpData:{
            data:{}
        },
        earning_potential_data: {
          data: [],
          isFetching: false
        }
      };

    case ActionTypes.START_GET_EARNING_POTENTIAL:
      return {
        ...state,
        earning_potential_data: {
          ...state.earning_potential_data,
          isFetching: true
        }
      };

    case ActionTypes.GET_EARNING_POTENTIAL_SUCCESS:
      if (
        action.data &&
        action.data.earning_potential_configs &&
        action.data.earning_potential_configs.length
      ) {
        return {
          ...state,
          earning_potential_data: {
            ...state.earning_potential_data,
            data: action.data.earning_potential_configs,
            isFetching: false,
            noDataForCity: false
          }
        };
      } else {
        return {
          ...state,
          earning_potential_data: {
            data: [],
            isFetching: false,
            noDataForCity: true
          }
        };
      }

    case ActionTypes.START_SIGN_UP:
      return {
        ...state,
        signUpData: {
          ...state.signUpData,
          isFetching: true
        }
      };

    case ActionTypes.SUCCESS_SIGN_UP:
      return {
        ...state,
        signUpData: {
          ...state.signUpData,
          isFetching: false,
          errorMessage: action.data.error,
          data: action.data?action.data:{}
        }
      };
      

    case ActionTypes.ERROR_SIGN_UP:
      return {
        ...state,
        signUpData: {
          ...state.signUpData,
          isFetching: false,
          errorMessage: action.errorMessage
        }
      };

    case ActionTypes.START_LOGIN:
      return {
        ...state,
        loginData: {
          ...state.loginData,
          isFetching: true,
          isFetchingTwo: true
        }
      };

    case ActionTypes.SUCCESS_LOGIN:
      return {
        ...state,
        loginData: {
          ...state.loginData,
          isFetching: false,
          errorMessage: '',
          data: action.data
        }
      };

    case ActionTypes.ERROR_LOGIN:
      return {
        ...state,
        loginData: {
          ...state.loginData,
          isFetching: false,
          errorMessage: action.errorMessage,
          isFetchingTwo: false
        }
      };

    case ActionTypes.START_OTP:
      return {
        ...state,
        otpData: {
          ...state.otpData,
          isFetching: true
        }
      };

    case ActionTypes.SUCCESS_OTP:
      if (path(action,"data.status",false)) {
        let time = new Date().getTime();
        action.data['expiration_time'] = time + 180000;
        return {
          ...state,
          otpData: {
            ...state.otpData,
            isFetching: false,
            data: action.data
          }
        };
      } else if (
        !action.data.success &&
        action.data.error
      ) {
        return {
          ...state,
          otpData: {
            ...state.otpData,
            isFetching: false,
            errorMessage: action.data.error
          }
        };
      }

      return {
        ...state,
        otpData: {
          ...state.otpData,
          isFetching: false
        }
      };

    case ActionTypes.ERROR_OTP:
      return {
        ...state,
        otpData: {
          ...state.otpData,
          isFetching: false,
          errorMessage: action.errorMessage
        }
      };

    case ActionTypes.CAROUSEL_MODE_UPDATE:
      return {
        ...state,
        carousel_mode: action.data
      };
    case ActionTypes.UPDATE_GLOBAL_DATA:
      return {
        ...state,
        ...action.payload
      };
    default:
      return {
        ...state
      };
  }
}
